<template>
  <div class="footer-warnings">
    <div v-for="(image, index) in images" :key="index" class="footer-warnings__item">
      <img :src="getImagePath(image)" alt="" />
    </div>
  </div>
</template>

<script>
import compatibleRequire from "@app_components/helpers/compatibleRequire";

export default {
  name: "FooterWarnings",
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getImagePath(name) {
      return compatibleRequire(require(`@static_common/images/${name}`));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/footer-warnings.scss";
</style>
